const BASE_FORMATS = [
  'background',
  'bold',
  'color',
  'font',
  'code',
  'italic',
  'link',
  'size',
  'strike',
  'script',
  'underline',
  'blockquote',
  'header',
  'indent',
  'list',
  'align',
  'direction',
  'code-block',
  'formula',
];

export const editorDefaultFormats = [...BASE_FORMATS, 'image'];

export const editorFormatsWithoutImage = [...BASE_FORMATS];
